'use client';

import { routes } from '@/config/routes';

const ONBOARDING_SETUP_SEEN_KEY = 'cresivox-onboarding-setup-seen';

function canUseLocalStorage() {
  return typeof window !== 'undefined';
}

export function hasSeenOnboardingSetup() {
  if (!canUseLocalStorage()) {
    return false;
  }

  return localStorage.getItem(ONBOARDING_SETUP_SEEN_KEY) === 'true';
}

export function markOnboardingSetupSeen() {
  if (!canUseLocalStorage()) {
    return;
  }

  localStorage.setItem(ONBOARDING_SETUP_SEEN_KEY, 'true');
}

export function getPostAuthRedirectPath(fallbackPath: string, onboardingComplete?: boolean) {
  // onboardingComplete undefined means the caller couldn't determine real
  // completion state (e.g. social/OTP login) — fall back to the legacy
  // localStorage flag rather than forcing onboarding on every such login.
  if (onboardingComplete === undefined) {
    return hasSeenOnboardingSetup() ? fallbackPath : routes.onboardingSetup;
  }

  return onboardingComplete ? fallbackPath : routes.onboardingSetup;
}
